export default [

  {
    stid: 'VGAC1',
    name: 'VIRGINIA LAKES RstidGE',
    priority: 1,
    color: 'rgba(255, 99, 132, 0.2)',
    borderColor: 'rgba(255, 99, 132, 1)',
  },

  {
    stid: 'TIRC1',
    name: 'TIOGA PASS ENTRY STATION NEAR TUOLUMNE MEADOWS 7ENE (TES)',
    priority: 2,
    color: 'rgba(255, 99, 132, 0.2)',
    borderColor: 'rgba(255, 99, 132, 1)',
  },

  {
    stid: 'ERYC1',
    name: 'ELLERY LAKE NEAR LEE VINING 6WSW (ERY)',
    priority: 3,
    color: 'rgba(255, 206, 86, 0.2)',
    borderColor: 'rgba(255, 206, 86, 1)',
  },

  {
    stid: 'AGPC1',
    name: 'AGNEW PASS NEAR TUOLUMNE MEADOWS 15SE (AGP)',
    priority: 4,
    color: 'rgba(255, 99, 132, 0.2)',
    borderColor: 'rgba(255,99,132,1)',
  },

  {
    stid: 'JEMC1',
    name: 'GEM PASS NEAR JUNE LAKE 5W (GEM)',
    priority: 5,
    color: 'rgba(75, 192, 192, 0.2)',
    borderColor: 'rgba(75, 192, 192, 1)',
  },

  {
    stid: 'JMWC1',
    name: 'JUNE MOUNTAIN WEATHER PLOT NEAR JUNE LAKE 2S (JMW)',
    priority: 6,
    color: 'rgba(153, 102, 255, 0.2)',
    borderColor: 'rgba(153, 102, 255, 1)',
  },

  {
    stid: 'MTH01',
    name: 'Mammoth Chair 1 Summit',
    priority: 8,
    color: 'rgba(255, 159, 64, 0.2)',
    borderColor: 'rgba(255, 99, 132, 1)',
  },

  {
    stid: 'MTH02',
    name: 'Mammoth Chair 22 Summit',
    priority: 9,
    color: 'rgba(63, 191, 63, 0.2)',
    borderColor: 'rgba(255, 99, 132, 1)',
  },

  {
    stid: 'MTH05',
    name: 'Mammoth Sesame Snow Study Plot',
    priority: 10,
    color: 'rgba(255, 99, 132, 0.2)',
    borderColor: 'rgba(255, 99, 132, 1)',
  },

  {
    stid: 'MAMC1',
    name: 'MAMMOTH PASS NEAR MAMMOTH LAKES 4WSW (MHP)',
    priority: 11,
    color: 'rgba(63, 191, 191, 0.2)',
    borderColor: 'rgba(255, 159, 64, 1)',
  },

  {
    stid: 'RCKC1',
    name: 'ROCK CREEK LAKES NEAR SCHEELITE 7NW (RCK)',
    priority: 12,
    color: 'rgba(255, 99, 132, 0.2)',
    borderColor: 'rgba(255, 99, 132, 1)',
  },

  {
    stid: 'SOUC1',
    name: 'SOUTH LAKE CABIN NEAR BISHOP 16SSW (SLK)',
    priority: 13,
    color: 'rgba(191, 63, 191, 0.2)',
    borderColor: 'rgba(191, 63, 191, 1)',
  },

  {
    stid: 'SAWC1',
    name: 'SAWMILL NEAR BIG PINE 15W (SWM)',
    priority: 14,
    color: 'rgba(96, 128, 255, 0.2)',
    borderColor: 'rgba(96, 128, 255, 1)',
  },

  {
    stid: 'BGPC1',
    name: 'BIG PINE CREEK NEAR BIG PINE 11WSW (BGP)',
    priority: 15,
    color: 'rgba(54, 162, 235, 0.2)',
    borderColor: 'rgba(54, 162, 235, 1)',
  },

];



// WEBPACK FOOTER //
// ./src/models/favorite-stations.js